import { gettext } from '@eventbrite/i18n';
import { getLayer } from '@eventbrite/statsig';
import {
    OnlyWhenUrgencySignalsEnabled,
    UrgencyCategories,
    UrgencyMessages,
    UrgencySignalsProps,
} from '@eventbrite/urgency-signals';
import React from 'react';
import { LISTING_PAGE_EARLY_BIRD_EXPERIMENT } from '../../constants';

export const UrgencySignalsWrapper: React.FC<{
    urgencySignals: UrgencySignalsProps;
}> = ({ urgencySignals }) => {
    const isEarlyBirdUrgencySignalDisplayed =
        urgencySignals?.categories?.earlyBird;
    const earlyBirdExperimentValue = isEarlyBirdUrgencySignalDisplayed
        ? getLayer(
              LISTING_PAGE_EARLY_BIRD_EXPERIMENT.layer,
              LISTING_PAGE_EARLY_BIRD_EXPERIMENT.param,
              LISTING_PAGE_EARLY_BIRD_EXPERIMENT.defaultValue,
          )
        : false;

    const isEarlyBirdDiscountVariant =
        earlyBirdExperimentValue ===
        LISTING_PAGE_EARLY_BIRD_EXPERIMENT.discountVariant;

    const isEarlyBirdSpecialVariant =
        earlyBirdExperimentValue ===
        LISTING_PAGE_EARLY_BIRD_EXPERIMENT.specialVariant;

    return (
        <OnlyWhenUrgencySignalsEnabled>
            <div>
                <div className="urgency-signals">
                    <div className="eds-show-down-mn">
                        <UrgencyMessages />
                    </div>
                    {isEarlyBirdSpecialVariant ? (
                        <UrgencyCategories
                            labelOverrides={{
                                earlyBird:
                                    gettext('Early bird special').toString(),
                            }}
                        />
                    ) : isEarlyBirdDiscountVariant ? (
                        <UrgencyCategories
                            labelOverrides={{
                                earlyBird: gettext(
                                    'Early bird discount',
                                ).toString(),
                            }}
                        />
                    ) : (
                        <UrgencyCategories />
                    )}
                </div>
            </div>
        </OnlyWhenUrgencySignalsEnabled>
    );
};
